import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import rootReducers from "./redux/rootReducer";
import { authApiAction } from "./redux/apiSlices/authApiSlice";
import { ordersApiAction } from "./redux/apiSlices/orderApi/orderApiSlice";
import { clientsApiAction } from "./redux/apiSlices/clientApi/clientApiSlice";
import { productsApiAction } from "./redux/apiSlices/productApi/productApiSlice";
import { driversApiAction } from "./redux/apiSlices/driverApi/driverApiSlice";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      authApiAction.middleware,
      ordersApiAction.middleware,
      clientsApiAction.middleware,
      productsApiAction.middleware,
      driversApiAction.middleware,
   
    ]),
});

export const persistor = persistStore(store);